import { CodeBase } from "./_codeBase";

/**
 * 使用可能レベル
 */
export class AvailabilityLevel extends CodeBase<AvailabilityLevel>
{
    /** 使用可能レベル: 0, "none" */
    public static readonly NONE: AvailabilityLevel = new AvailabilityLevel(0, "NONE");
    /** 使用可能レベル: 1, "R" */
    public static readonly R: AvailabilityLevel = new AvailabilityLevel(1, "R");
    /** 使用可能レベル: 2, "R/W" */
    public static readonly RW: AvailabilityLevel = new AvailabilityLevel(2, "RW");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): AvailabilityLevel[] {
        return [
            AvailabilityLevel.NONE,
            AvailabilityLevel.R,
            AvailabilityLevel.RW,
        ];
    }
}
